// import { useEffect } from "react";
import { sendEmailVerificationRequest } from "../../features/EmailVerificationSlice";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import SpinnerGif from "../../videos/Spinner.gif";
import VerifiedGif from "../../videos/Verified.gif";
import declinedGif from "../../videos/declined.GIF";
import { useScrollToTop } from "../../Utility";
import { useEffect } from "react";

let flagHasBeenCalled = true;
export const EmailVerificationPage = () => {
  // * At the top of the page.
  useScrollToTop();

  // * Get Redux state
  const dispatch = useDispatch();
  useEffect(() => {
    if (flagHasBeenCalled) {
      dispatch(sendEmailVerificationRequest());
      flagHasBeenCalled = false;
    }
  }, [dispatch]);

  const verificationState = useSelector((state) => state.emailVerification);

  const verificationSuccess = useSelector(
    (state) => state.emailVerification
  ).response;
  const verificationError = useSelector(
    (state) => state.emailVerification
  ).error;

  const gradientBackground = {
    background: "linear-gradient(to bottom, #16181C , #0D0F12)",
  };
  return (
    <>
      <div
        className={`relative isolate overflow-hidden min-h-screen bg-gray-900 pt-24 pb-16  sm:pt-32 sm:pb-28 bg-cover bg-center`}
        style={gradientBackground}
      >
        {/*  Background colors  */}
        <div
          className="hidden sm:absolute sm:-top-10 sm:right-1/2 sm:-z-10 sm:mr-10 sm:block sm:transform-gpu sm:blur-3xl"
          aria-hidden="true"
        >
          <div
            className="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-tr from-[#ff4694] to-[#776fff] opacity-20"
            style={{
              clipPath:
                "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
            }}
          />
        </div>
        <div
          className="absolute -top-52 left-1/2 -z-10 -translate-x-1/2 transform-gpu blur-3xl sm:top-[-28rem] sm:ml-16 sm:translate-x-0 sm:transform-gpu"
          aria-hidden="true"
        >
          <div
            className="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-tr from-[#ff4694] to-[#776fff] opacity-20"
            style={{
              clipPath:
                "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
            }}
          />
        </div>

        {/* Start Content here */}
        {/* Content wrapper */}

        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          {/* Display text information */}

          {!verificationState.loading ? (
            <div className="mx-auto max-w-2xl lg:mx-0">
              <h2
                className={`text-4xl font-bold tracking-tight ${
                  verificationState.success ? "text-white" : "text-red-400"
                } sm:text-6xl`}
              >
                {verificationState.success ? (
                  <>
                    Hello {verificationState.clientName} thank you for sing up.
                  </>
                ) : (
                  <>
                    Hello {verificationState.clientName} your email verification
                    failed.
                  </>
                )}
              </h2>

              {/* Success or Error msg */}
              <p
                className={`mt-8 text-lg leading-8 text-gray-300 tracking-wide font-semibold`}
              >
                {verificationState.success ? (
                  <>{verificationSuccess.msg}</>
                ) : (
                  <>Because {verificationError?.msg}</>
                )}
              </p>

              {/* Navigation */}
              <div className="space-y-3">
                {/*  Button */}
                <Link to={"/login"}>
                  <button
                    type="submit"
                    className="flex justify-center w-full sm:w-fit  rounded-md bg-Brand-Color hover:bg-Brand-Color-Light  px-3  my-4 py-1.5 text-sm  leading-6 text-white font-bold shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#ffa200e8]"
                  >
                    {verificationState.success
                      ? "Login now"
                      : "New Sing up Attempt?"}
                  </button>
                </Link>
              </div>
              <Link to={"mailto:jsononclouds@gmail.com"}>
                <p className="text-Brand-Color font-semibold hover:underline inline-flex">
                  Contact Us
                </p>
              </Link>
            </div>
          ) : (
            <></>
          )}

          {/* Gif Show */}
          <div className=" flex flex-col justify-center items-center my-[10vh]">
            {/* Loding */}
            {verificationState.loading ? (
              <div className="flex flex-col items-center justify-center">
                <h4 className="text-Brand-Color-Light font-extrabold text-lg mt-3 tracking-wider max-w-2xl">
                  {/* {emailVerificationMsg} */}
                </h4>
                <img
                  src={SpinnerGif}
                  alt="lodging gif"
                  className="w-32 h-32 "
                />
              </div>
            ) : (
              <></>
            )}

            {/* Error */}

            {!verificationState.success && !verificationState.loading ? (
              <div className="flex flex-col items-center justify-center">
                <h4 className="text-Brand-Color-Light font-extrabold text-lg mt-3 tracking-wider max-w-2xl">
                  {/* {emailVerificationMsg} */}
                </h4>
                <img
                  src={declinedGif}
                  alt="verification failed gif"
                  className="w-20 h-20 "
                />
              </div>
            ) : (
              <></>
            )}

            {/* Success */}
            {verificationState.success && !verificationState.loading ? (
              <div className="flex flex-col items-center justify-center">
                <h4 className="text-Brand-Color-Light font-extrabold text-lg mt-3 tracking-wider max-w-2xl">
                  {/* {emailVerificationMsg} */}
                </h4>
                <img
                  src={VerifiedGif}
                  alt="verification successfully complete gif"
                  className="w-20 h-20 "
                />
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
